import React from "react";
import "./Footer.css";
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from "react-icons/fa";
import {FaX} from "react-icons/fa6";
import {RiTwitterXFill} from "react-icons/ri";
const JonoonLogo = "/images/JONOON_Logo_Trans.png";

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-section">
                    <h3>Contact Us</h3>
                    <p>Amman, Jordan</p>
                    <p>+962 7 1234 5678</p>
                    <p>jonoon.company@gmail.com</p>
                </div>
                <div className="footer-section">
                    <h3>Useful Links</h3>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li><a href="/About">About</a></li>
                        <li><a href="/Contact">Contact</a></li>
                        <li><a href="/ticket-check">Ticket Check</a></li>
                    </ul>
                </div>
                <div className="footer-section">
                    <h3>Follow Us</h3>
                    <div className="social-icons">
                        <a href="https://www.instagram.com/jonoon_entertainment?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                        <a href="https://www.facebook.com/profile.php?id=61561559182710" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
                        <a href="https://x.com/JonoonCompany" target="_blank" rel="noopener noreferrer"><RiTwitterXFill /></a>
                        <a href="https://jo.linkedin.com/company/jonoon?trk=public_profile_experience-item_profile-section-card_subtitle-click" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
                    </div>
                    <div className="footer-section">
                        <img src={JonoonLogo} alt="JONOON Logo" className="footer-logo" />
                    </div>
                </div>
            </div>
            <p className="footer-text">© 2025 JONOON. All rights reserved.</p>
        </footer>
    );
}
export default Footer;
